import { render, staticRenderFns } from "./PredictionTablev2.vue?vue&type=template&id=5e290252&scoped=true&"
import script from "./PredictionTablev2.vue?vue&type=script&lang=js&"
export * from "./PredictionTablev2.vue?vue&type=script&lang=js&"
import style0 from "./PredictionTablev2.vue?vue&type=style&index=0&id=5e290252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e290252",
  null
  
)

export default component.exports